export const getContent = (content, word, lang) => {
    if (content === null){
        return "No Content";
    } else if(content[word] === undefined){
        return word + "_null";
    } else if(content[word][lang] === undefined){
        return word + "_" + lang;
    } else {
        return content[word][lang];
    }
}